import { render, staticRenderFns } from "./TimsDatetimepicker.vue?vue&type=template&id=0b85d771&scoped=true&"
import script from "./TimsDatetimepicker.vue?vue&type=script&lang=ts&"
export * from "./TimsDatetimepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85d771",
  null
  
)

export default component.exports